<template>
    <div class="no_data column_center">
        <img src="../assets/no_data_2.png" alt="">
        <div class="d_txt">暂无相关数据</div>
    </div>
</template>

<script>
    export default {
        name: "no_data"
    }
</script>

<style scoped lang="scss">
    .no_data {
        width: 100%;
        padding: 100px;
        box-sizing: border-box;
        img {
            width: 400px;
            height: 400px;
        }
        .d_txt {
            font-size: 18px;
            color: #8c8c8c;
        }
    }
</style>
